export const checkBrowserLangInLangsArrayHelper = (langArray, lang) => {
  if (!lang) {
    return "ru";
  }

  return langArray
    .find((item) => item.code === lang?.toUpperCase())
    ?.code.toLowerCase();
};
